import React, { Component } from 'react';
import { Tooltip } from "@mui/material";

import TextInput from "../../../component/input/TextInput";
import MessageDetailModal from "../component/modal/MessageDetailModal";
import Alert from "../../../component/modal/Alert";

import * as apiUtil from "../../../util/apiUtil";
import * as stringUtil from "../../../util/stringUtil";
import * as dateUtil from "../../../util/dateUtil";
import * as messageUtil from "../../../util/messageUtil";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sentMessageAction from "../store/sentMessage";
import Loading from "../../../component/loading/Loading";
import DateTimeInput from "../../../component/input/DateTimeInputNew";
import UpdateImageModal from "../component/modal/UpdateImageModal";
import ImageListContainer from "../../selfmessage/image/container/ImageListContainer";

class SentUpdateContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.ajaxGetSentMessageForUpdate = this.ajaxGetSentMessageForUpdate.bind(this);
        this.ajaxMessageUpdate = this.ajaxMessageUpdate.bind(this);

        this.setValue = this.setValue.bind(this);
        this.handleDetailModal = this.handleDetailModal.bind(this);
        this.handleUpdateImageModal = this.handleUpdateImageModal.bind(this);

        this.openAlert = this.openAlert.bind(this);
        this.closeAlert = this.closeAlert.bind(this);

        this.state = {
            loading: false,

            detailModal: false,
            updateImageModal: false,

            alertOpen: false,
            alertMessage: '',
            alertButtons: [],

            channelList: [],
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.detailModal !== nextState.detailModal
            || this.props.messageDetail !== nextProps.messageDetail
            || this.state.updateImageModal !== nextState.updateImageModal
            || this.props.updateMsgName !== nextProps.updateMsgName
            || this.props.updateMsgSndInitDate !== nextProps.updateMsgSndInitDate
            || this.props.updateMsgSndDate !== nextProps.updateMsgSndDate
            || this.props.updateMsgSndHour !== nextProps.updateMsgSndHour
            || this.props.updateMsgSndMinute !== nextProps.updateMsgSndMinute
            || this.state.alertOpen !== nextState.alertOpen
            || this.state.alertMessage !== nextState.alertMessage
            || this.state.alertButtons !== nextState.alertButtons
        )
    }

    componentDidMount() {
        this.ajaxGetSentMessageForUpdate();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    ajaxGetSentMessageForUpdate() {
        const { uid } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/" + uid + "?m=U",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const { SentMessageAction } = this.props;
                SentMessageAction.setMessageDetail(result.info);
                SentMessageAction.setUpdateMsgName(result.info.name);
                SentMessageAction.setUpdateMsgSndDate(result.info.sndDate);

                this.setState({ channelList: result.info.sendChannel.split(",")})
            }
        })
    }

    ajaxMessageUpdate() {
        if (! window.confirm("메시지를 수정하시겠습니까?")) return;

        const { uid } = this.props;
        const { updateMsgName, updateMsgSndDate, updateMsgSndHour, updateMsgSndMinute } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/update/" + uid,
            method: apiUtil.requestMethod.POST,
            data: {
                name: updateMsgName,
                sndDate: dateUtil.dateTimeToStr(new Date(updateMsgSndDate + " " + updateMsgSndHour + ":" + updateMsgSndMinute)),
            },
            success: (result) => {
                this.openAlert(
                    "메시지 수정이 완료 되었습니다.",
                    [
                        { onClick: function() {window.location.href = "/sent/detail/" + uid},  label: "확인", className: "btn btn-primary" }
                    ]
                )
            }
        })
    }

    openAlert(message, buttons) {
        this.setState({ alertOpen: true, alertMessage: message, alertButtons: buttons });
    }

    closeAlert() {
        const { alertOpen } = this.state;
        this.setState({ alertOpen: ! alertOpen });
    }

    setValue(id, value) {
        const { SentMessageAction } = this.props;

        switch (id) {
            case "name":
                SentMessageAction.setUpdateMsgName(value);
                break;
            case "sendDate":
                SentMessageAction.setUpdateMsgSndDate(value);
                break;
            default:
                break;
        }
    }

    handleDetailModal() {
        const { detailModal } = this.state;
        this.setState({ detailModal: ! detailModal })
    }

    handleUpdateImageModal() {
        const { updateImageModal } = this.state;
        this.setState({ updateImageModal: ! updateImageModal })
    }

    render() {
        const { loading } = this.state;

        const { detailModal, channelList, updateImageModal } = this.state;
        const { uid } = this.props;
        const { messageDetail, updateMsgName, updateMsgSndDate, updateMsgSndHour, updateMsgSndMinute, updateMsgSndInitDate } = this.props;
        const { setValue, ajaxMessageUpdate, handleDetailModal, handleUpdateImageModal } = this;

        const { alertOpen, alertMessage, alertButtons } = this.state;
        const { closeAlert } = this;

        return (
            <>
                <Loading loading={loading}/>
                <div className='container-xxl mb-5'>
                    <h2 className='fs-4'>메시지 수정</h2>
                    <div className='card'>
                        <div className='card-body send-update'>
                            <div className='table-responsive'>
                                <table className="table table-bordered">
                                    <thead className='table-primary border'>
                                        <tr>
                                            <th colSpan="6">발송 메시지 기본 정보</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className='w-10'>메시지 명</th>
                                            <td className='w-40' colSpan='2'>
                                                <TextInput
                                                    className="form-control w-auto"
                                                    type="text"
                                                    id="name"
                                                    value={updateMsgName}
                                                    onChange={setValue}
                                                />
                                            </td>
                                            <th className='w-10'>발신 번호</th>
                                            <td className='w-40' colSpan='2'>{stringUtil.formatPhone(messageDetail.callback)}</td>
                                        </tr>
                                        <tr>
                                            <th>메시지 상태</th>
                                            <td colSpan='2'>{messageDetail.state !== messageUtil.BIZCHAT_STATUS_REQUEST && messageDetail.stateDesc}</td>
                                            <th>
                                                <Tooltip title={"검수는 영업일 기준 2~3일 소요 될 수 있습니다."}>
                                                    <div className='d-flex align-items-center pointer'>
                                                        <span>검수 상태</span>
                                                        <span className="material-symbols-rounded ps-1 fs-5 text-primary">info</span>
                                                    </div>
                                                </Tooltip>
                                            </th>
                                            <td colSpan='2'>{messageDetail.adminStateDesc}</td>
                                        </tr>
                                        <tr>
                                            <th>메시지 발송 일자</th>
                                            <td colSpan='2'>
                                                {
                                                    messageDetail.rcvType === 0 ?
                                                        <DateTimeInput
                                                            className={'form-control'}
                                                            changeValue={setValue}
                                                            initDate={updateMsgSndInitDate}
                                                            date={updateMsgSndDate}
                                                            hour={updateMsgSndHour}
                                                            minute={updateMsgSndMinute}
                                                        />
                                                        : <span>{messageDetail.sndDate}</span>
                                                }
                                            </td>
                                            <th>메시지 타깃</th>
                                            <td colSpan='2'>{stringUtil.formatNumber(messageDetail.sndMosu)} 명</td>
                                        </tr>
                                        <tr>
                                            <th>목표 발송 건수</th>
                                            <td colSpan='2'>{stringUtil.formatNumber(messageDetail.sndGoalCnt)} 건</td>
                                            <th>소진 포인트</th>
                                            <td colSpan='2'>{stringUtil.formatNumber(messageDetail.budget)} P</td>
                                        </tr>
                                        <tr>
                                            <th>발송 서비스</th>
                                            <td colSpan="2">{messageDetail.sendChannel}</td>
                                            <th>메시지 내용</th>
                                            <td colSpan="1">
                                                <div className="d-flex gap-2">
                                                    <button className='btn btn-outline-primary btn-sm' onClick={handleDetailModal}>메시지 내용 확인하기</button>
                                                    { messageDetail.sendChannel && messageDetail.sendChannel.includes('이미지') &&
                                                        (messageDetail.state === messageUtil.BIZCHAT_STATUS_REJECTED ||
                                                            messageDetail.state === messageUtil.BIZCHAT_STATUS_GOUN_APPROVED ||
                                                            messageDetail.state === messageUtil.BIZCHAT_STATUS_REGISTERED ) &&
                                                        <button className='btn btn-outline-primary btn-sm' onClick={handleUpdateImageModal}>이미지 수정하기</button>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className='text-center'>
                                <button className='btn btn-primary mx-1 btn-md' onClick={ajaxMessageUpdate}>저장</button>
                                <button className='btn btn-secondary mx-1 btn-md' onClick={()=>window.location.href = "/sent/detail/" + uid} >취소</button>
                            </div>
                        </div>
                    </div>
                </div>
                <MessageDetailModal isOpen={detailModal} onClose={handleDetailModal} channelList={channelList} cmpnUid={uid}/>
                <UpdateImageModal
                    key={messageDetail.rcsType ?? 0}
                    rcsType={messageDetail.rcsType ?? 0}
                    isOpen={updateImageModal}
                    onClose={handleUpdateImageModal}
                    cmpnUid={uid}
                />
                <Alert
                    isOpen={alertOpen}
                    handleClose={closeAlert}
                    message={alertMessage}
                    buttons={alertButtons}
                />
            </>
        )
    }
}

export default connect(
    (state) => ({
        messageDetail: state.sentMessage.get('messageDetail'),
        updateMsgName: state.sentMessage.get('updateMsgName'),
        updateMsgSndInitDate: state.sentMessage.get('updateMsgSndInitDate'),
        updateMsgSndDate: state.sentMessage.get('updateMsgSndDate'),
        updateMsgSndHour: state.sentMessage.get('updateMsgSndHour'),
        updateMsgSndMinute: state.sentMessage.get('updateMsgSndMinute'),
    }),
    (dispatch) => ({
        SentMessageAction: bindActionCreators(sentMessageAction, dispatch),
    })
)(SentUpdateContainer);
